var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-container"},[_c('div',{staticClass:"echarts-line",attrs:{"id":_vm.lineId}})])}
var staticRenderFns = []

export { render, staticRenderFns }